const reLoginUrl = `${
  process.env[`REACT_APP_COGNITO_URL_${process.env.REACT_APP_ENV}`]
}/oauth2/authorize?response_type=code&client_id=${
  process.env[`REACT_APP_COGNITO_CLIENT_ID_${process.env.REACT_APP_ENV}`]
}&redirect_uri=${process.env[`REACT_APP_COGNITO_REDIRECT_URI_${process.env.REACT_APP_ENV}`]}`;

const ReLogin = () => {
  window.location.href = reLoginUrl;
};

module.exports = ReLogin;



// WEBPACK FOOTER //
// ./src/components/authentication/ReLogin.js